import React, { useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import { Config } from '@leverege/plugin';
import { Content, Text, Button, IconUtil, Pane, Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { History } from '@leverege/molten-core';
import S from './InactivityScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.support.InactivityScreen');
function InactivityScreen(props) {
  const {
    dispatch,
    title,
    msg,
    url,
    button,
    image
  } = props;
  let mTitle = title === undefined ? Config.get('InactivityScreen', 'title', t('title')) : title;
  const mMsg = msg === undefined ? Config.get('InactivityScreen', 'message', t('message')) : msg;
  const mButton = button === undefined ? Config.get('InactivityScreen', 'button', t('button')) : button;
  let mUrl = url === undefined ? Config.get('InactivityScreen', 'link', () => localStorage.getItem('lastActivePage') || '/') : url;
  const mImg = image === undefined ? Config.get('InactivityScreen', 'image', 'https://molten-ui-assets.storage.googleapis.com/timeout.svg') : image;
  useEffect(() => {
    Dialogs.hideAll();
  }, []);
  const img = useMemo(() => {
    if (Array.isArray(mImg)) {
      return mImg[Math.floor(Math.random() * mImg.length) % mImg.length];
    }
    return mImg;
  }, [mImg]);
  if (typeof mUrl === 'function') {
    mUrl = mUrl();
  }
  if (typeof mTitle === 'string') {
    mTitle = /*#__PURE__*/_jsx(Text, {
      variant: "inactivityTitle|title",
      children: mTitle
    });
  }
  return /*#__PURE__*/_jsx(Content, {
    horizontal: true,
    variant: "editor",
    children: /*#__PURE__*/_jsx(Content.Area, {
      variant: "inactivityScreen",
      className: S.area,
      children: /*#__PURE__*/_jsxs(Pane, {
        variant: "inactivityScreenContent",
        className: S.content,
        children: [mImg && /*#__PURE__*/_jsx("div", {
          className: S.fontIcon,
          children: IconUtil.create(img, {
            width: '80%'
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [mTitle, /*#__PURE__*/_jsx(Text, {
            variant: "inactivityCaption|caption",
            children: mMsg
          }), mUrl && /*#__PURE__*/_jsx(Button, {
            className: S.continue,
            onClick: () => {
              localStorage.removeItem('lastActivePage');
              dispatch(History.replace(mUrl));
            },
            children: mButton
          })]
        })]
      })
    })
  });
}
export default connect((state, ownProps) => {
  return {};
})(InactivityScreen);